<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "product-group",
  created() {
    document.title = "中国国际医疗器械博览会 - 产品展示组";
  }
};
</script>

<style scoped lang="scss">
</style>
